import 'bootstrap';
import { Controller } from '@hotwired/stimulus';
import $ from 'jquery';

export default class extends Controller {
  static targets = ['tip'];

  connect() {
    const self = this;
    self.initializeTips();
    $('body').on('ajax-content-loaded, react-render', () => {
      self.initializeTips();
    });
  }

  initializeTips() {
    this.tipTargets.forEach((el) => {
      const ctr = $(el).data('container') || 'body';
      const placement = $(el).data('placement') || 'top';
      const tipClass = $(el).data('tipclass') || '';
      if ($(el).data('initialized') !== 'true') {
        $(el).tooltip({
          container: ctr,
          placement,
          trigger: 'hover',
          html: true,
          template: `<div class="tooltip ${tipClass}" role="tooltip"><div class="arrow"></div><div class="tooltip-inner"></div></div>`,
        });
        $(el).data('initialized', 'true');
      }
    });
  }
}
